import React from 'react';
import { format } from 'date-fns';
import { Receipt } from 'lucide-react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';

const TransactionsTable = ({
    transactions,
    isLoading,
    getInvoiceId,
    getStatusColor,
    onViewReceipt
}) => {
    if (isLoading) {
        return (
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead className="w-[180px]">Invoice ID</TableHead>
                        <TableHead className="w-[150px]">Date</TableHead>
                        <TableHead className="w-[150px]">Credits</TableHead>
                        <TableHead className="w-[120px]">Status</TableHead>
                        <TableHead className="w-[100px]">Actions</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {Array(5).fill(0).map((_, i) => (
                        <TableRow key={i}>
                            <TableCell><Skeleton className="h-4 w-24" /></TableCell>
                            <TableCell><Skeleton className="h-4 w-32" /></TableCell>
                            <TableCell><Skeleton className="h-4 w-16" /></TableCell>
                            <TableCell><Skeleton className="h-4 w-20" /></TableCell>
                            <TableCell><Skeleton className="h-4 w-24" /></TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    }

    return (
        <Table>
            <TableHeader>
                <TableRow>
                    <TableHead className="w-[180px] min-w-32">Invoice ID</TableHead>
                    <TableHead className="w-[150px] min-w-32">Date</TableHead>
                    <TableHead className="w-[150px] min-w-32">Credits</TableHead>
                    <TableHead className="w-[120px] min-w-32">Status</TableHead>
                    <TableHead className="w-[100px] min-w-32">Actions</TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                {transactions.map((transaction) => (
                    <TableRow key={transaction.id}>
                        <TableCell className="font-medium">
                            {getInvoiceId(transaction.id)}
                        </TableCell>
                        <TableCell>
                            {format(new Date(transaction.created_at), 'MMM dd, yyyy')}
                        </TableCell>
                        <TableCell className={getStatusColor(transaction.amount)}>
                            {transaction.amount.toLocaleString()} credits
                        </TableCell>
                        <TableCell>
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">
                                Completed
                            </span>
                        </TableCell>
                        <TableCell>
                            <Button
                                variant="ghost"
                                size="sm"
                                className="flex items-center gap-2"
                                onClick={() => onViewReceipt(transaction)}
                            >
                                <Receipt className="h-4 w-4" />
                                View Receipt
                            </Button>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};

export default TransactionsTable;